<template>
    <b-col cols="10" offset-md="2">
      <b-alert :show="showErrorAlta" dismissible @dismissed="showErrorAlta=false" variant="danger">Error al dar de alta la base {{model.schema_name}}: {{response.msg}}</b-alert>
      <b-alert :show="showOkAlta" dismissible @dismissed="showOkAlta=false" variant="success">La base {{model.schema_name}} se dio de alta correctamente.</b-alert>
      <b-row class="justify-content-center">
        <b-container class="m-3">
          <b-row>
            <b-col>Numero de Bases por Servidor Synagro 7</b-col>
            <b-col>
              <div class="text-center">
              <b-button variant="primary">
                TSC8      <b-badge variant="light">{{ this.basestsc8 }}</b-badge>
              </b-button>
              </div>      
            </b-col>
            <b-col>

              <div class="text-center">
              <b-button variant="primary">
                TSC9      <b-badge variant="light">{{ this.basestsc9 }}</b-badge>
              </b-button>
              </div>
            </b-col>
            <b-col>

              <div class="text-center">
              <b-button variant="primary">
                TSC10      <b-badge variant="light">{{ this.basestsc10 }}</b-badge>
              </b-button>
              </div>

              
            </b-col>
            <b-col>
            <div class="text-center">
              <b-button variant="primary">
                TSC11      <b-badge variant="light">{{ this.basestsc11 }}</b-badge>
              </b-button>
              </div>
            </b-col>

            <b-col>
            <div class="text-center">
              <b-button variant="primary">
                TSC12      <b-badge variant="light">{{ this.basestsc12 }}</b-badge>
              </b-button>
              </div>
            </b-col>

            <b-col>
            <div class="text-center">
              <b-button variant="primary">
                TSC6      <b-badge variant="light">{{ this.basestsc6 }}</b-badge>
              </b-button>
              </div>
            </b-col>

            <b-col>
            <div class="text-center">
              <b-button variant="primary">
                TSC5      <b-badge variant="light">{{ this.basestsc5 }}</b-badge>
              </b-button>
              </div>
            </b-col>
            
            <b-col>
            <div class="text-center">
              <b-button variant="primary">
                TSC13      <b-badge variant="light">{{ this.basestsc13 }}</b-badge>
              </b-button>
              </div>
            </b-col>
          </b-row>
        </b-container>
        <b-card title="Restaurar copia de Base desde un Backup">
          <b-overlay
            :show="loading"
            spinner-variant="primary"
            spinner-type="grow"
            spinner-large
            rounded="sm"
          >
            <b-form id="formID" @submit.prevent="onSubmit" method="POST" class="form-row needs-validation" ref="formID">
              
              <b-form-group class="col-md-4 col-sm-6">
                <label for="serverorigen">Servidor Origen</label>
                <b-form-select  id="serverorigen" v-model="serverorigen" :options="servidores" placeholder="Servidor origen" required></b-form-select>
              </b-form-group>

              <b-form-group class="col-md-4 col-sm-6">
                <label for="tar_list_input">Archivo TAR</label>
                <b-form-input list="tar_list" id="tar_list_input" v-model="model.file_name_tar" placeholder="Busca y selecciona un archvo tar" required></b-form-input>
                <b-form-datalist id="tar_list" :options="tar_list"></b-form-datalist>
              </b-form-group>

              <b-form-group class="col-md-4 col-sm-6">
                <label for="file_list_input">Archivo Backup</label>
                <b-form-input list="file_list" id="file_list_input" v-model="model.file_name_bkp" placeholder="Busca y selecciona un backup dentro del tar" required></b-form-input>
                <b-form-datalist id="file_list" :options="file_list"></b-form-datalist>
              </b-form-group>
              
              <b-form-group class="col-md-4 col-sm-6">
                <label for="sistema">Sistema</label>
                <b-form-input list="sistema-list" id="sistema" v-model="model.sistema" placeholder="Busca y selecciona el tipo de sistema" required></b-form-input>
                <b-form-datalist id="sistema-list" :options="sistemas"></b-form-datalist>
              </b-form-group>

              <b-form-group class="col-md-4 col-sm-6">
                <label for="nombre">Nombre Grupo</label>
                <b-form-input id="nombre" v-model="model.nombre" placeholder="Ingresa un nombre de Grupo" required></b-form-input>
              </b-form-group>

              <b-form-group class="col-md-4 col-sm-6">
                <label for="schema_name">Nombre Tecnico</label>
                <b-form-input id="schema_name" v-model="model.schema_name" placeholder="Ingresa un nombre tecnico" :state="validation" required></b-form-input>
                <b-form-invalid-feedback :state="validation">
                  {{ schemaname_msg }}
                </b-form-invalid-feedback>
                <b-form-valid-feedback :state="validation">
                  {{schemaname_msg}}
                </b-form-valid-feedback>
              </b-form-group>

              <b-form-group v-if="!pisar_base" class="col-md-4 col-sm-6">
                <label for="descripcion">Descripcion de la base</label>
                <b-form-input id="descripcion" v-model="model.descripcion" placeholder="Descripcion" :state="validation2"></b-form-input>
                <b-form-invalid-feedback :state="validation2">
                  {{ descripcion_msg }}
                </b-form-invalid-feedback>
                <b-form-valid-feedback :state="validation2">
                  Descripcion correcta
                </b-form-valid-feedback>
              </b-form-group>
              

              <b-form-group class="col-md-4 col-sm-6">
                <label for="server1">Servidor destino</label>
                <b-form-select  id="server1" v-model="model.server_name" :options="servidores" placeholder="Servidor destino" required></b-form-select>
              </b-form-group>

              <b-form-group class="col-md-4 col-sm-6">
                <label for="version">Version Sistema</label>
                <b-form-input list="version-list" id="version" v-model="model.version" placeholder="Version de sistema" required></b-form-input>
                <b-form-datalist id="version-list" :options="versiones"></b-form-datalist>
              </b-form-group>
              <!-- descrip_empresa -->
              <b-form-group class="col-md-4 col-sm-6">
                <label for="descrip_empresa">Razon Social</label>
                <b-form-input id="descrip_empresa" v-model="model.descrip_empresa" placeholder="Razon social" required></b-form-input>
              </b-form-group>

               <b-form-group class="col-md-4 col-sm-6">
                <label for="zona">Zona</label>
                <b-form-input list="zona-list" id="zona" v-model="model.zona" placeholder="Zona" required></b-form-input>
                <b-form-datalist id="zona-list" :options="zonas"></b-form-datalist>
              </b-form-group>

              <!-- <b-form-group class="col-md-4 col-sm-6">
                <label for="empresa">Empresa Origen</label>
                <b-form-input list="empresa-list" id="empresa" v-model="model.empresa" placeholder="empresa"></b-form-input>
                <b-form-datalist id="empresa-list" :options="empresa"></b-form-datalist>
              </b-form-group> -->

               <b-form-group class="col-md-4 col-sm-6">
                <label for="fecha_liberacion">Fecha liberacion:</label>
                <b-form-datepicker   id="fecha_liberacion" v-model="model.fecha_liberacion"></b-form-datepicker>
              </b-form-group>

              <b-form-group class="col-md-4 col-sm-6">
                <label for="db_tipo_id">Tipo de base</label>
                <b-form-select list="db_tipo_id-list" id="db_tipo_id" v-model="model.db_tipo_id" :options="db_tipo_id" required></b-form-select>
              </b-form-group>

              <b-form-group class="col-md-4 col-sm-6">
                <label for="aplicacion_tipos">Tipo aplicacion/pais </label>
                <b-form-select id="aplicacion_tipos" v-model="model.aplicacion_tipos" :options="aplicacion_tipos" required></b-form-select>
              </b-form-group>

              <div class="w-100"></div>

              <h5>Evento</h5>

              <div class="w-100"></div>

              <b-form-group class="col-md-4 col-sm-6">
                <label for="solicitante">Solicitante</label>
                <b-form-input id="solicitante" v-model="model.solicitante" placeholder="Ingresa nombre del solicitante" required></b-form-input>
              </b-form-group>

              <b-form-group class="col-md-4 col-sm-6">
                <label for="evento_descrip">Motivo</label>
                <b-form-input id="evento_descrip" v-model="model.evento_descrip" placeholder="Ingresa descricion del alta o Copia" required></b-form-input>
              </b-form-group>

              <div class="w-100"></div>

              <b-form-group class="col-md-3 col-sm-6">
                <b-form-checkbox v-model="model.habilita_campo" value="S" unchecked-value="N" switch size="lg">Habilita Campo</b-form-checkbox>
              </b-form-group>

              <b-form-group class="col-md-3 col-sm-6">
                <b-form-checkbox v-model="model.habilita_contabilidad" value="S" unchecked-value="N" switch size="lg">Habilita Contabilidad</b-form-checkbox>
              </b-form-group>

              <b-form-group class="col-md-3 col-sm-6">
                <b-form-checkbox v-model="model.habilita_construccion" value="S" unchecked-value="N" switch size="lg">Habilita Construccion</b-form-checkbox>
              </b-form-group>

              <b-form-group class="col-md-3 col-sm-6">
                <b-form-checkbox v-model="model.habilita_sueldo" value="1" unchecked-value="0" switch size="lg">Habilita Sueldos</b-form-checkbox>
              </b-form-group>

              <b-form-group class="col-md-3 col-sm-6">
                <b-form-checkbox v-model="model.habilita_mobile" value="1" unchecked-value="0" switch size="lg">Habilita Mobile</b-form-checkbox>
              </b-form-group>
              

              <b-form-group v-if="!schemaname_isvalid || pisar_base || schemaname_isvalid == null"  class="col-md-3 col-sm-6">
                <b-form-checkbox v-model="pisar_base" switch size="lg" @change="checkDatabaseName(model.schema_name)">Pisar base existente</b-form-checkbox>
              </b-form-group>

              <b-form-group v-if="pisar_base" class="col-md-3 col-sm-6">
                <b-form-checkbox v-model="model.drop_database" value="1" unchecked-value="0" switch size="lg">Al pisar base, hacer <strong>DROP</strong> antes</b-form-checkbox>
              </b-form-group>

              
              <b-button type="submit" size="lg" variant="outline-primary">Enviar</b-button>

            </b-form>   
          </b-overlay>

        </b-card >
      </b-row>
      
    </b-col>

</template>

<script>
import {TokenService} from "./../storage/service"

export default {
  name: 'RestoreBackup',
  props: {
    msg: String
  },
  data: function () {
    return {
      pisar_base: false,
      showErrorAlta: false,
      showOkAlta: false,
      loading: false,
      modelos: [], //traera de api de forma dinamica
      sistemas: ['UNICA', 'CAMPO', 'CONT', 'PACKING'],
      servidores: [], //traer de API
      tar_list: [], //traer de API
      file_list: [], //traer de API
      versiones: ['2', '5', '6', '7'], //traer de API
      zonas: [], //Traer de API
      empresa: ['TS', 'SISTEC'],
      db_tipo_id: [], // traer de API 
      aplicacion_tipos: [], //TRAER de api
      schemaname_isvalid: null,
      schemaname_msg: "",
      descripcion_isvalid: null,
      descripcion_msg: "",
      response: {},
      serverorigen: "",
      basestsg8: "",
      basestsg9: "",
      basestsg10: "",
      basestsg11: "",
      model: {
        //Dafaults Values
        drop_database: 0,
        server1: "",
        num_server: this.server1,
        srv_app_updt: 'synagro0.dnsalias.com',
        habilita_tesoreria: 1,
        fecha_liberacion: "",
        schema_name: "",
        habilita_db_solo_lectura: 0,
        serverorigen: "",
        file_name_tar: "",
        file_name_bkp: "",
        server_name: "",
        empresa: "TS",
        habilita_campo: "N",
        habilita_contabilidad: "N",
        habilita_construccion: "N",
        habilita_sueldo: 0,
        habilita_mobile: 0
      }
    };
  },
  mounted() {
    this.login();
    this.fetchServers();
    this.fetchDbTipos();
    this.fetchDbZonas();
    this.fetchNumberBase();
    this.fetchAplicacionTipos();
    // console.log(this);
    
  },

  methods: {
      login(){
        let token = TokenService.getToken()
        this.$http.post(this.backendURL + 'api/v1.0/checkSession/', {headers: {'Authorization': 'Token ' + token}})
        .then(() => {
          console.log("Token Correcto")
        })
        .catch(err => {
          // catch error});
          if(err.request.statusText == 'Unauthorized'){
            alert("Su sesion ha expirado...")
            this.$store.dispatch('logout')
            .then(() => {
              this.$router.push('/login')
            })
          }
          else {
            console.log(err.data)
          }
        })
      },
    onSubmit(){
      // Valida si hay algun field invalido
      var forms = document.getElementById('formID');
      if (forms.getElementsByClassName('is-invalid').length > 0) {
        console.log("Corrija los errores del formulario")
        return
      }
      this.loading = true
      // Asigamos fecha de alta al modelo
      let creacion_date = new Date()
      this.model['fecha_creacion'] = creacion_date.getFullYear() + "-" + (Number(creacion_date.getMonth()) + 1) + "-" + creacion_date.getDate()    

      //busca y asocia el num_server de la lista de servidores con el modelo
      for(var servidor in this.servidores){
        if(this.servidores[servidor].value == this.model.server_name){
          this.model.num_server = this.servidores[servidor].num_server
          this.model.puerto = this.servidores[servidor].puerto
          // asignamos a demas campos de servidores el mismo valor que servidor
          this.model.server1 = this.servidores[servidor].host
          this.model.server2 = this.servidores[servidor].host
          this.model.server3 = this.servidores[servidor].host
          this.model.server4 = this.servidores[servidor].host
          this.model.server5 = this.servidores[servidor].host
          this.model.server6 = this.servidores[servidor].host
          this.model.server7 = this.servidores[servidor].host
          this.model.server1_central = this.servidores[servidor].host
          this.model.server2_central = this.servidores[servidor].host
          //manda id de mysql
          this.model.server_id = this.servidores[servidor].server_id
          break;
        }
      }

      // envia el post
      this.$http.post(this.backendURL + 'api/v1.0/restauracion_base/', this.model)
      .then(res => {
          // do something with res
          console.log(res.data);
          this.response = res.data
          this.loading = false
          if(this.response.msg.includes("ok")){
            this.showOkAlta = true
          }
          else {
            this.showErrorAlta = true;
          }
      })
      .catch(err => {
          // catch error});
          console.log(err.data)
          this.response = err.data
          this.loading = false;
          this.showErrorAlta = true;
          this.catchError(err)
      })
      
    },

    fetchServers() {
      let url = this.backendURL + 'api/v1.0/MySQL/';
      this.$http.get(url)
      .then( result => {
        //console.log(result.data)
        for(var i in result.data){
          this.servidores.push({value: result.data[i].name, num_server: result.data[i].server.cod_server, text: result.data[i].name, puerto: result.data[i].port, server_id: result.data[i].server.id, host: result.data[i].server.host})
        }
      })
      .catch(err => {
        this.catchError(err)
      })
    },

    fetchNumberBase(){
      let url = this.backendURL + 'api/v1.0/number_of_bases/';
      this.$http.get(url)
      .then(result => {
        this.basestsc8 = result.data.tsc8
        this.basestsc9 = result.data.tsc9
        this.basestsc10 = result.data.tsc10
        this.basestsc11 = result.data.tsc11
        this.basestsc12 = result.data.tsc12
        this.basestsc5 = result.data.tsc5
        this.basestsc6 = result.data.tsc6
        this.basestsc13 = result.data.tsc13
        console.log(this.basestsc8, this.basestsc9, this.basestsc10, this.basestsc5)
      })
      .catch(err => {
        this.catchError(err)
      })
    },

    fetchDbTipos(){
      let url = this.backendURL + 'api/v1.0/DbTipos/';
      this.$http.get(url)
      .then( result => {
        //console.log(result.data)
        for(var i in result.data){
          this.db_tipo_id.push({value: result.data[i].id, text: result.data[i].nombre})
        }
      })
      .catch(err => {
        this.catchError(err)
      })
    },

    fetchDbZonas(){
      let url = this.backendURL + 'api/v1.0/ZonasEmpresas/';
      this.$http.get(url)
      .then( result => {
        //console.log(result.data)
        for(var i in result.data){
          this.zonas.push(result.data[i].zona)
        }
      })
      .catch(err => {
        this.catchError(err)
      })
    },

    fetchAplicacionTipos() {
      let url = this.backendURL + 'api/v1.0/AplicacionTipos/';
      this.$http.get(url)
      .then( result => {
        //console.log(result.data)
        for(var i in result.data){
          this.aplicacion_tipos.push({value: result.data[i].aplicacion_tipos_id, text: result.data[i].aplicacion_tipo})
        }
      })
      .catch(err => {
        this.catchError(err)
      })
    },

    fetch_tar_list() {
      for(var servidor in this.servidores){
        if(this.servidores[servidor].value == this.serverorigen){
          console.log("Host: " + this.servidores[servidor].host)
          this.model.serverorigen = this.servidores[servidor].host
          break;
        }
      }
      this.tar_list = [];
      this.$http.post(this.backendURL + 'api/v1.0/backups_tar_list/', this.model)
      .then( result => {
        for(var i in result.data){
          this.tar_list.push(result.data[i])
        }
      })
      .catch(err => {
        this.catchError(err)
      })
    },

    fetch_file_list() {
      console.log(this.model)
      this.file_list = [];
      this.$http.post(this.backendURL + 'api/v1.0/backups_file_list/', this.model)
      .then( result => {
        for(var i in result.data){
          this.file_list.push(result.data[i])
        }
      })
      .catch(err => {
        this.catchError(err)
      })
    },
  
    checkDatabaseName(kword){
      this.$http.get(this.backendURL + 'api/v1.0/Bases/?kword='+kword)
      .then(res => {
          if(res.data.length > 0 && !this.pisar_base){
            console.log(this.pisar_base)
            this.schemaname_isvalid = false
            this.schemaname_msg = "El nombre de la base de datos ya existe"
          }
          else if(res.data.length > 0 && this.pisar_base){
            this.schemaname_isvalid = true
            this.schemaname_msg = "La copia pisara la base existente. La descripcion mantendra la misma que la original. Los demas datos se actualizaran segun este formulario"
          }
          else if(this.schema_name.length > 25 || this.schema_name.length < 5){
              this.schemaname_isvalid = false
              this.schemaname_msg = "El nombre de la base de datos debe tener entre 5 y 25 caracteres"
          }
          
          else{
            this.modelos['schema_name'] = this.schema_name
            this.schemaname_isvalid = true
            this.schemaname_msg = "El nombre tecnico es correcto"
            this.pisar_base = false
          }            
            
      })
      .catch(err => {
          // catch error});
          this.catchError(err)
      })
    },
    checkDatabaseDescripcion(kword){
      this.$http.get(this.backendURL + 'api/v1.0/Descripcion/?kword='+kword)
      .then(res => {
          if(res.data.length > 0){
            this.descripcion_isvalid = false
            this.descripcion_msg = "La descripcion ya existe"
          }
          else if(this.model.descripcion.length < 5){
              this.descripcion_isvalid = false
              this.descripcion_msg = "Descripcion debe ser mayor a 5 caracteres"
          }
          else{
            this.descripcion_isvalid = true;
          }            
            
      })
      .catch(err => {
          // catch error});
          this.this.catchError(err)
      })
    },
    
    catchError(err){
      if(err.request.statusText == 'Unauthorized'){
        alert("Su sesion ha expirado...")
        this.$store.dispatch('logout')
        .then(() => {
          this.$router.push('/login')
        })
      }
      else {
        console.log(err.data)
      }
    }
  },

  computed: {
    validation() {
        return this.schemaname_isvalid
      },
    validation2() {
        return this.descripcion_isvalid
      },
    schema_name(){
      return this.model.schema_name;
    },
    descripcion(){
      return this.model.descripcion;
    },
    servidororigen(){
      return this.serverorigen;
    },
    tarfile(){
      return this.model.file_name_tar;
    }
  },

  watch: {
    schema_name(val){
      console.log(val)
      this.checkDatabaseName(val)
    },
    descripcion(val){
      console.log(val)
      this.checkDatabaseDescripcion(val)
    },

    servidororigen(val){
      console.log(val)
      this.fetch_tar_list(val)
    },

    tarfile(val){
      this.fetch_file_list(val)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 25px 0 25px 0;
}

#formID{
  padding: 20px;
}
</style>
